import { GetterTree } from 'vuex';
import { RootState } from '../../state';
import uiState, {
  CreatorScope,
  AiShellSettings,
  AiShellAttachment,
  AiShellActivityFlags,
  AiShellViewMode,
  AiShellPreviewRole,
  AiShellDataSourceMode,
  AiShellWidgetSummary,
  AiShellStreamingCreation
} from './state';

// eslint-disable-next-line no-shadow
export const enum GetterTypes {
  isAiShellOpen = 'isAiShellOpen',
  getAiShellScope = 'getAiShellScope',
  getAiShellEntityId = 'getAiShellEntityId',
  getAiShellEntityName = 'getAiShellEntityName',
  getAiShellEntityDesc = 'getAiShellEntityDesc',
  getAiShellEntityIcon = 'getAiShellEntityIcon',
  getAiShellEntityColor = 'getAiShellEntityColor',
  getAiShellContext = 'getAiShellContext',
  getAiShellSettings = 'getAiShellSettings',
  getAiShellAttachments = 'getAiShellAttachments',
  getAiShellActivityFlags = 'getAiShellActivityFlags',
  getAiShellPendingGeneration = 'getAiShellPendingGeneration',
  getAiShellHasUnsavedChanges = 'getAiShellHasUnsavedChanges',
  getAiShellSaveRequested = 'getAiShellSaveRequested',
  getAiShellViewMode = 'getAiShellViewMode',
  getAiShellPreviewRole = 'getAiShellPreviewRole',
  getAiShellDataSourceMode = 'getAiShellDataSourceMode',
  getAiShellWidgetSummary = 'getAiShellWidgetSummary',
  getAiShellProgramEditApplied = 'getAiShellProgramEditApplied',
  getAiShellStreamingCreation = 'getAiShellStreamingCreation',
  getAiShellInitialPrompt = 'getAiShellInitialPrompt'
}

type UiGetterCtx<T> = (
  state: typeof uiState,
  getters: any,
  rootState: RootState,
  rootGetters: any
) => T;

export interface UiGetters extends GetterTree<typeof uiState, RootState> {
  isAiShellOpen: UiGetterCtx<boolean>;
  getAiShellScope: UiGetterCtx<CreatorScope>;
  getAiShellEntityId: UiGetterCtx<string | null>;
  getAiShellEntityName: UiGetterCtx<string | null>;
  getAiShellEntityDesc: UiGetterCtx<string | null>;
  getAiShellEntityIcon: UiGetterCtx<string | null>;
  getAiShellEntityColor: UiGetterCtx<string | null>;
  getAiShellContext: UiGetterCtx<Record<string, unknown> | null>;
  getAiShellSettings: UiGetterCtx<AiShellSettings>;
  getAiShellAttachments: UiGetterCtx<AiShellAttachment[]>;
  getAiShellActivityFlags: UiGetterCtx<AiShellActivityFlags>;
  getAiShellPendingGeneration: UiGetterCtx<Record<string, unknown> | null>;
  getAiShellHasUnsavedChanges: UiGetterCtx<boolean>;
  getAiShellSaveRequested: UiGetterCtx<boolean>;
  getAiShellViewMode: UiGetterCtx<AiShellViewMode>;
  getAiShellPreviewRole: UiGetterCtx<AiShellPreviewRole>;
  getAiShellDataSourceMode: UiGetterCtx<AiShellDataSourceMode>;
  getAiShellWidgetSummary: UiGetterCtx<AiShellWidgetSummary | null>;
  getAiShellProgramEditApplied: UiGetterCtx<boolean>;
  getAiShellStreamingCreation: UiGetterCtx<AiShellStreamingCreation>;
  getAiShellInitialPrompt: UiGetterCtx<string | null>;
}

export const getters: UiGetters = {
  isAiShellOpen: state => state.aiShellOpen,
  getAiShellScope: state => state.aiShellScope,
  getAiShellEntityId: state => state.aiShellEntityId,
  getAiShellEntityName: state => state.aiShellEntityName,
  getAiShellEntityDesc: state => state.aiShellEntityDesc,
  getAiShellEntityIcon: state => state.aiShellEntityIcon,
  getAiShellEntityColor: state => state.aiShellEntityColor,
  getAiShellContext: state => state.aiShellContext,
  getAiShellSettings: state => state.aiShellSettings,
  getAiShellAttachments: state => state.aiShellAttachments,
  getAiShellActivityFlags: state => state.aiShellActivityFlags,
  getAiShellPendingGeneration: state => state.aiShellPendingGeneration,
  getAiShellHasUnsavedChanges: state => state.aiShellHasUnsavedChanges,
  getAiShellSaveRequested: state => state.aiShellSaveRequested,
  getAiShellViewMode: state => state.aiShellViewMode,
  getAiShellPreviewRole: state => state.aiShellPreviewRole,
  getAiShellDataSourceMode: state => state.aiShellDataSourceMode,
  getAiShellWidgetSummary: state => state.aiShellWidgetSummary,
  getAiShellProgramEditApplied: state => state.aiShellProgramEditApplied,
  getAiShellStreamingCreation: state => state.aiShellStreamingCreation,
  getAiShellInitialPrompt: state => state.aiShellInitialPrompt
};
